import { useCallback, useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import { ReactComponent as CameraSwitch} from '../../../../images/icons/camera-switch.svg';

interface Props{
    webcamRef: React.RefObject<Webcam>
}
interface IDevice{
  label: string;
  deviceId: string;
  groupId: string;
  kind: string
}
type Devices = IDevice[];

const WebcamCapture = ({ webcamRef }: Props) => {
    
  const [deviceId, setDeviceId] = useState("");
  const [devices, setDevices] = useState<Devices>([]);
  const [index, setIndex] = useState(0);

  const handleDevices = useCallback((mediaDevices: Devices) => {
    setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput"));
    },
    [setDevices]
  );

  useEffect(
    () => {
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
    },
    [handleDevices]
  );

  const changeCamera = () => {
    if (devices.length > 0) {
      const devicesIds = devices.map(device => device.deviceId);
      if (index + 1 < devicesIds.length) {
        setIndex(state => state + 1);
      } else {
        setIndex(0);
      }
      setDeviceId(devicesIds[index]);
    }
  }  
    const videoConstraints = {
      width: 220,
      height: 220,
      deviceId
    };

    return (
        <div className="relative bg-[#D9D9D9] mt-[12px] mb-[11px] inline-block overflow-hidden rounded-full w-[226px] h-[226px] border-solid border-white border-[6px] shadow-[4px_4px_19px_rgba(0,0,0,0.25)]">
          <Webcam audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints} />
        <button onClick={changeCamera}
          className="absolute flex justify-center items-center bottom-[8px] left-1/2 -translate-x-1/2 w-[45px] h-[45px] rounded-full border-[2px] border-white bg-[#030303] opacity-40">
          <CameraSwitch/>
        </button>
        </div>
)
}

export default WebcamCapture;